import { SolutionCardType, WorkflowCardType, ChooseCardType } from 'sections/Services/TradeFinance/types';

export const solutionCardsData: SolutionCardType[] = [
  {
    id: 1,
    iconName: 'icon-invoice',
    iconAlt: 'Invoice Factoring Icon',
    heading: 'Invoice Factoring',
  },
  {
    id: 2,
    iconName: 'icon-chart',
    iconAlt: 'Invoice Discounting Icon',
    heading: 'Invoice Discounting',
  },
  {
    id: 3,
    iconName: 'icon-communication',
    iconAlt: 'Reverse Factoring Icon',
    heading: 'Reverse Factoring',
  },
  {
    id: 4,
    iconName: 'icon-invoice',
    iconAlt: 'Trade Payables Financing Icon',
    heading: 'Trade Payables Financing',
  },
  {
    id: 5,
    iconName: 'icon-documents',
    iconAlt: 'Inventory Financing Icon',
    heading: 'Inventory Financing',
  },
];

export const workflowCardsData: WorkflowCardType[] = [
  {
    id: 1,
    heading: 'Register Online',
    description: 'Submit basic KYC details about your business',
  },
  {
    id: 2,
    heading: 'Credit Facility Application',
    description: 'Request credit facility from financial institution that fits your business needs',
  },
  {
    id: 3,
    heading: 'Underwriting',
    description: 'Financial institution will complete underwriting process & provide term sheet',
  },
  {
    id: 6,
    heading: 'Dashboard & Analytics',
    description: 'Refer to dashboard for real time status update on your transactions, shipments & payments',
  },
  {
    id: 5,
    heading: 'Funds Disbursment',
    description: 'Financial institution will disburse funds directly to your account',
  },
  {
    id: 4,
    heading: 'Submit Invoice ',
    description: 'Securely submit your shipment documents (invoices, BLs) for financing',
  },
];

export const chooseCardsData: ChooseCardType[] = [
  {
    id: 1,
    iconName: 'icon-currency',
    iconAlt: 'Global Financial Institutions',
    heading: 'Access to Global Financial Institutions',
    description: 'Providing SME’s access to FI’s globally in one platform.',
  },
  {
    id: 2,
    iconName: 'icon-chart',
    iconAlt: 'Competitive rates',
    heading: 'Competitive rates',
    description: 'Offering access to attractive credit lines and multiple currencies​.',
  },
  {
    id: 3,
    iconName: 'icon-laptop',
    iconAlt: 'Efficiency',
    heading: 'Efficiency',
    description: 'Responsive approval decisions supported by robust and intelligent systems.',
  },
  {
    id: 4,
    iconName: 'icon-coins',
    iconAlt: 'Digitalization',
    heading: 'Digitalization',
    description: 'Seamlessly Exchange Documents and Data to Eliminate Discrepancies​.',
  },
  {
    id: 5,
    iconName: 'icon-layers',
    iconAlt: 'Transparency',
    heading: 'Transparency',
    description: 'Get transaction level visibility in detail via role-based access​.',
  },
  {
    id: 6,
    iconName: 'icon-wave',
    iconAlt: 'Convenient & User Friendly',
    heading: 'Convenient & User Friendly',
    description: 'Simplified online application with streamlined document requirements​.',
  },
];